import InboxConnectWizardCore from 'InboxConnectUtils/components/InboxConnectWizardCore';
import { createDefaultService } from 'InboxConnectUtils/service/ServiceFactory';
import PortalIdParser from 'PortalIdParser';
import events from 'InboxConnectUtils/events.yaml';
import { useCallback, useState } from 'react';
import { Button } from 'foundations-components/transitional/components/Button';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { ShareToolTabLeftSection, ShareToolTabRightSection, ShareToolTabWholeSection } from './ShareToolLayout';
import { EmailPreview } from './EmailPreview';
import { useAuthContext } from '../../context/AuthContext';
import { ShareToolTabFooter } from './ShareToolTabFooter';
import { ShareToolCloseButton } from './ShareToolCloseButton';
import { getAppName, getTracker, trackUsage } from '../../usage-tracker/track';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const EmailNotConnected = ({
  onConnect,
  description
}) => {
  const [isWizardOpen, setIsWizardOpen] = useState(false);
  const [isConnectionComplete, setIsConnectionComplete] = useState(false);
  const {
    hasScope
  } = useAuthContext();
  const hasConnectedEmailInboxAccess = hasScope('connected-email-inbox-access');
  const service = createDefaultService({
    tracker: getTracker().clone({
      events
    }),
    appName: getAppName(),
    portalId: PortalIdParser.get()
  });
  const handleOnDone = useCallback(connectedAccount => {
    setIsWizardOpen(false);
    setIsConnectionComplete(true);
    onConnect === null || onConnect === void 0 || onConnect(connectedAccount);
  }, [onConnect]);
  if (isWizardOpen) {
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(ShareToolTabWholeSection, {
        dataTestId: "inbox-connect-wizard",
        children: /*#__PURE__*/_jsx(View, {
          paddingInline: "50",
          children: /*#__PURE__*/_jsx(InboxConnectWizardCore, {
            service: service,
            onDone: handleOnDone,
            showExtensionInstall: false
          })
        })
      }), /*#__PURE__*/_jsx(ShareToolTabFooter, {
        children: /*#__PURE__*/_jsx(ShareToolCloseButton, {})
      })]
    });
  }
  if (isConnectionComplete) {
    return null;
  }
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(ShareToolTabLeftSection, {
      children: [/*#__PURE__*/_jsx("p", {
        children: description
      }), /*#__PURE__*/_jsx(Tooltip, {
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "CommerceToolsUiLib.shareToolModal.emailTab.emailNotConnected.noPermission"
        }),
        disabled: hasConnectedEmailInboxAccess,
        placement: "bottom",
        children: /*#__PURE__*/_jsx(Button, {
          use: "tertiary",
          onClick: () => {
            trackUsage({
              action: 'click set up connect email inbox button'
            });
            setIsWizardOpen(true);
          },
          disabled: !hasConnectedEmailInboxAccess,
          block: true,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "CommerceToolsUiLib.shareToolModal.emailTab.emailNotConnected.connectInbox"
          })
        })
      })]
    }), /*#__PURE__*/_jsx(ShareToolTabRightSection, {
      children: /*#__PURE__*/_jsx(EmailPreview, {})
    }), /*#__PURE__*/_jsx(ShareToolTabFooter, {
      children: /*#__PURE__*/_jsx(ShareToolCloseButton, {})
    })]
  });
};